import { useDemoFetcherWithSwr } from "@/api";
import { userAtom } from "@/atoms/userAtom";
import { useAtomValue } from "jotai";

/**
 * プロフィール完了状態をチェックするカスタムフック
 *
 * 全環境でプロフィール取得を実行し、
 * profile_completed フラグを確認する
 */
export const useProfileCheck = () => {
  const user = useAtomValue(userAtom);

  // ユーザーがログイン済みの場合のみプロフィールを取得
  const shouldFetchProfile = !!user?.userId;

  const {
    data: profile,
    error,
    isLoading
  } = useDemoFetcherWithSwr({
    apiName: "user_config",
    serviceName: "profile",
    operationId: "getProfile",
    requestParameters: {
      userId: user?.userId || ""
    },
    enabled: shouldFetchProfile,
    swrConfiguration: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false
    }
  });

  // プロフィール未完了かどうか
  // error が発生した場合は、ログ出力してフェイルオープン（完了済みとして扱う）
  // profile が undefined の場合は、まだ取得中なので false を返す（リダイレクトしない）
  // profile が取得できた場合のみ、profile_completed の値で判定
  const isProfileIncomplete =
    shouldFetchProfile && !error && profile !== undefined && profile.profile_completed === false;

  // エラー時のログ出力（フェイルオープン）
  if (error && shouldFetchProfile) {
    console.error("プロフィール取得失敗:", error);
  }

  return {
    isProfileIncomplete,
    isLoading: shouldFetchProfile ? isLoading : false,
    error
  };
};
